import { render, staticRenderFns } from "./AssetDispatchTable.vue?vue&type=template&id=6b60ac83"
import script from "./AssetDispatchTable.vue?vue&type=script&lang=js"
export * from "./AssetDispatchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports